import TranslatedValueCreate from "@/models/translated-value/TranslatedValueCreate";
import {ValidationRule} from "@/declarations/ValidationRule";
import BrandRules from "@/models/brand/BrandRules";
import ModelUpdate from "@/models/ModelUpdate";
import {IBrandAdmin} from "@/models/brand/BrandAdminModels";
import TranslatedValueUpdate from "@/models/translated-value/TranslatedValueUpdate";

export default class BrandUpdate extends ModelUpdate<IBrandAdmin> {
	public name: string | null = null;
	public description: TranslatedValueCreate = new TranslatedValueCreate();

	public constructor(model: IBrandAdmin) {
		super();
		this.setDetailModel(model);
	}

	protected initializeWithDetailModelData(detailModel: IBrandAdmin) {
		this.name = detailModel.name;
		this.description = new TranslatedValueUpdate(detailModel.description);
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'name':
				return BrandRules.nameRules;
			default:
				return [];
		}
	}
}
